import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";

interface ProtectedRouteProps {
  requiredRole?: string;
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredRole, allowedRoles }) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const hasAccess = (() => {
    if (allowedRoles && allowedRoles.length > 0) {
      return user?.role != null && allowedRoles.includes(user.role);
    }
    if (requiredRole) {
      return user?.role === requiredRole;
    }
    return true;
  })();

  if (!hasAccess) {
    if (user?.role === "SuperAdmin") {
      return <Navigate to="/tenants" replace />;
    } else if (user?.role === "TruckDriver") {
      return <Navigate to="/truck-driver" replace />;
    } else {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
